import { cloneElement, Children } from 'react';
const handleTabClick = (setTabIndex, setAriaFocusIndex, onTabSelected, targetTab) => tabIndex => {
  setTabIndex(tabIndex);
  setAriaFocusIndex(tabIndex);
  if (typeof onTabSelected === 'function') {
    onTabSelected(tabIndex, targetTab);
  }
};
export const handleActiveIndicator = (tabsRef, indicatorRef, tabIndex, delayAnimation) => {
  const tabsNode = tabsRef.current;
  const indicatorNode = indicatorRef && indicatorRef.current;
  if (tabsNode && indicatorNode) {
    const activedChild = tabsNode.children[tabIndex];
    if (activedChild) {
      const tabContent = activedChild.children[0];
      if (tabContent) {
        const hasTransition = indicatorNode.style.transition;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !hasTransition || !indicatorNode.style.transform) {
          indicatorNode.style.transition = 'none';
        }
        indicatorNode.style.transform = `translateX(${tabContent.offsetLeft}px)`;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && (!hasTransition || !indicatorNode.style.transition.includes('transform'))) {
          setTimeout(() => {
            indicatorNode.style.transition = 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
          }, 10);
        }
        setTimeout(() => {
          indicatorNode.style.width = `${tabContent.offsetWidth}px`;
        }, delayAnimation ? 200 : 0);
      }
    }
  }
};
export const renderActiveTabContent = (props, activeTabIndex) => {
  const children = props.children;
  return children && children[activeTabIndex] ? children[activeTabIndex].props.children : null;
};
export const renderChildrenWithTabs = (props, activeTabIndex, setTabIndex, setAriaFocusIndex, targetTab) => {
  const {
    children,
    onTabSelected
  } = props;
  return Children.map(children, (child, index) => {
    const isActiveTab = index === activeTabIndex;
    return cloneElement(child, {
      handleTabClick: handleTabClick(setTabIndex, setAriaFocusIndex, onTabSelected, targetTab),
      tabIndex: index,
      isActive: isActiveTab,
      classes: 'tab',
      targetTab: targetTab
    });
  });
};
export const handleAriaMove = (tabsRef, tabIndex, keyPressed) => {
  const tabsNode = tabsRef.current;
  if (tabsNode) {
    const activedChild = tabsNode.children[tabIndex];
    if (activedChild) {
      keyPressed && activedChild.focus();
    }
  }
};
export const handleKeyPress = (event, props, activeAriaIndicatorIndex, activeIndicatorIndex, setAriaCurrentIndicatorIndex, setKeyboardUsed) => {
  if (!(event.key in AriaKeys)) {
    return;
  }
  setKeyboardUsed(true);
  const tabList = props.children;
  switch (event.key) {
    case AriaKeys.ArrowLeft:
      const nextLeft = activeAriaIndicatorIndex === 0 ? tabList.length - 1 : activeAriaIndicatorIndex - 1;
      setAriaCurrentIndicatorIndex(nextLeft);
      break;
    case AriaKeys.ArrowRight:
      const nextRight = activeAriaIndicatorIndex === tabList.length - 1 ? 0 : activeAriaIndicatorIndex + 1;
      setAriaCurrentIndicatorIndex(nextRight);
      break;
    case AriaKeys.Home:
      const nextHome = 0;
      setAriaCurrentIndicatorIndex(nextHome);
      break;
    case AriaKeys.End:
      const nextEnd = tabList.length - 1;
      setAriaCurrentIndicatorIndex(nextEnd);
      break;
    case AriaKeys.Tab:
    case AriaKeys.Tab && event.shiftKey:
      setAriaCurrentIndicatorIndex(activeIndicatorIndex);
      break;
    default:
      break;
  }
};
var AriaKeys = function (AriaKeys) {
  AriaKeys["ArrowLeft"] = "ArrowLeft";
  AriaKeys["ArrowRight"] = "ArrowRight";
  AriaKeys["Home"] = "Home";
  AriaKeys["End"] = "End";
  AriaKeys["Space"] = " ";
  AriaKeys["Enter"] = "Enter";
  AriaKeys["Tab"] = "Tab";
  return AriaKeys;
}(AriaKeys || {});
//# sourceMappingURL=util.js.map